













































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HemodynamicAnestesiChart from "@/components/chart/HemodynamicAnestesiChart.vue";
import PemantauanAnestesiSvc from "@/services/PemantauanAnestesiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: { HemodynamicAnestesiChart, VCDateTimePicker }
})
export default class PemantauanAnestesiGrafik extends Vue {
  @Prop() pemantauan!: any;
  @Prop({ default: false }) readonly!: boolean;

  dialogTtv = false;
  editingTtv: any = null;
  ttvValid = false;
  savingTtv = false;
  savingInline = false;
  countdownSeconds = 0;
  countdownTimer: any = null;

  // 5 baris input kosong default (menit 5,10,15,20,25 relatif nextMenit)
  inlineRows: any[] = [];
  fallbackBase = "";

  polaNafasOptions = [
    { text: "S+ (Spontan)", value: "spontan" },
    { text: "D+ (Dibantu)", value: "dibantu" },
    { text: "K+ (Kendali)", value: "kendali" },
  ];

  ttvForm: any = {
    waktu: "", tekanan_darah_sistolik: null, tekanan_darah_diastolik: null,
    nadi: null, spo2: null, etco2: null, pola_nafas: null,
    suhu: null, fio2: null, mac: null, catatan: "",
  };

  ttvHeaders = [
    { text: "Mnt", value: "menit_ke", width: "50px" },
    { text: "Waktu", value: "waktu", width: "80px" },
    { text: "TD", value: "td", width: "80px", sortable: false },
    { text: "Nadi", value: "nadi", width: "60px" },
    { text: "SpO2", value: "spo2", width: "60px" },
    { text: "EtCO2", value: "etco2", width: "60px" },
    { text: "Nafas", value: "label_pola_nafas", width: "70px" },
    { text: "Suhu", value: "suhu", width: "60px" },
    { text: "FiO2", value: "fio2", width: "50px" },
    { text: "MAC", value: "mac", width: "50px" },
    { text: "MAP", value: "map", width: "50px" },
    { text: "Catatan", value: "catatan" },
    { text: "", value: "actions", sortable: false, width: "70px" },
  ];

  mounted() {
    this.refreshFallbackBase();
    this.resetInlineRows();
    this.startCountdown();
  }

  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  @Watch("pemantauan.ttvs")
  onTtvsChanged() {
    this.refreshFallbackBase();
    this.startCountdown();
  }

  blankRow() {
    return {
      tekanan_darah_sistolik: null, tekanan_darah_diastolik: null,
      nadi: null, spo2: null, etco2: null, pola_nafas: null,
      suhu: null, fio2: null, mac: null, catatan: "",
    };
  }

  resetInlineRows(keep: any[] = []) {
    const blanks = Array.from({ length: 5 - keep.length }, () => this.blankRow());
    this.inlineRows = keep.concat(blanks);
  }

  refreshFallbackBase() {
    const last = this.lastTtv;
    if (last?.waktu) {
      this.fallbackBase = moment(last.waktu).add(5, "minutes").format("YYYY-MM-DDTHH:mm");
      return;
    }
    const now = moment().seconds(0).milliseconds(0);
    now.minutes(Math.floor(now.minutes() / 5) * 5);
    this.fallbackBase = now.format("YYYY-MM-DDTHH:mm");
  }

  get sortedTtvs() {
    if (!this.pemantauan?.ttvs) return [];
    return [...this.pemantauan.ttvs].sort(
      (a: any, b: any) => moment(a.waktu).valueOf() - moment(b.waktu).valueOf()
    );
  }

  get lastTtv(): any {
    const list = this.sortedTtvs;
    return list.length ? list[list.length - 1] : null;
  }

  get nextMenit(): number | null {
    if (!this.pemantauan?.mulai_anestesi_at) return null;
    const last = this.lastTtv;
    if (last && last.menit_ke !== null && last.menit_ke !== undefined) {
      return last.menit_ke + 5;
    }
    return 5;
  }

  get anchorWaktu(): string {
    if (this.pemantauan?.mulai_anestesi_at && this.nextMenit !== null) {
      return moment(this.pemantauan.mulai_anestesi_at)
        .add(this.nextMenit, "minutes")
        .format("YYYY-MM-DDTHH:mm");
    }
    return this.fallbackBase;
  }

  rowMenit(i: number): string {
    return this.nextMenit === null ? "-" : String(this.nextMenit + i * 5);
  }

  // Jam tampilan (HH:mm) untuk baris input ke-i
  rowWaktu(i: number): string {
    if (!this.anchorWaktu) return "";
    return moment(this.anchorWaktu).add(i * 5, "minutes").format("HH:mm");
  }

  // Jumlah baris input yang wajib-field-nya sudah terisi (TD sis/dia + nadi)
  get filledRowCount(): number {
    return this.inlineRows.filter((r: any) => r.tekanan_darah_sistolik && r.tekanan_darah_diastolik && r.nadi).length;
  }

  get chartDataSet() {
    const ttvs = this.sortedTtvs;
    const labels = ttvs.map((t: any) =>
      t.menit_ke !== null && t.menit_ke !== undefined ? t.menit_ke : this.formatTime(t.waktu)
    );
    const tensi = ttvs.map((t: any) => [t.tekanan_darah_diastolik, t.tekanan_darah_sistolik]);
    const nadi = ttvs.map((t: any) => t.nadi);
    const spo2 = ttvs.map((t: any) => t.spo2);
    const mapVal = ttvs.map((t: any) => t.map);

    return { labels, tensi, nadi, spo2, mapVal };
  }

  get ttvAlerts() {
    const alerts: string[] = [];
    if (!this.pemantauan?.ttvs) return alerts;
    const latest = this.sortedTtvs[this.sortedTtvs.length - 1];
    if (!latest) return alerts;

    if (latest.map !== null && latest.map < 65) {
      alerts.push(`MAP rendah: ${latest.map} mmHg (< 65)`);
    }
    if (latest.tekanan_darah_sistolik < 90) {
      alerts.push(`TD Sistolik rendah: ${latest.tekanan_darah_sistolik} mmHg`);
    }
    if (latest.tekanan_darah_sistolik > 180) {
      alerts.push(`TD Sistolik tinggi: ${latest.tekanan_darah_sistolik} mmHg`);
    }
    if (latest.spo2 !== null && latest.spo2 < 94) {
      alerts.push(`SpO2 rendah: ${latest.spo2}%`);
    }
    if (latest.etco2 !== null && (latest.etco2 < 30 || latest.etco2 > 45)) {
      alerts.push(`EtCO2 abnormal: ${latest.etco2} mmHg`);
    }
    return alerts;
  }

  get isOverdue() {
    return this.countdownSeconds < 0;
  }

  get countdownDisplay() {
    const abs = Math.abs(this.countdownSeconds);
    const m = Math.floor(abs / 60);
    const s = abs % 60;
    const prefix = this.countdownSeconds < 0 ? "-" : "";
    return `${prefix}${m}:${String(s).padStart(2, "0")}`;
  }

  startCountdown() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    if (this.pemantauan?.akhir_anestesi_at) return;

    const ttvs = this.sortedTtvs;
    if (ttvs.length === 0) return;

    const lastTtv = ttvs[ttvs.length - 1];
    const lastTime = moment(lastTtv.waktu);
    const nextDue = lastTime.clone().add(5, "minutes");

    this.countdownSeconds = nextDue.diff(moment(), "seconds");

    this.countdownTimer = setInterval(() => {
      this.countdownSeconds--;
    }, 1000);
  }

  tdAlertClass(item: any) {
    if (item.tekanan_darah_sistolik < 90 || item.tekanan_darah_sistolik > 180) {
      return "red--text font-weight-bold";
    }
    return "";
  }

  get waktuTtv(): Date | null {
    return this.ttvForm.waktu ? moment(this.ttvForm.waktu).toDate() : null;
  }

  set waktuTtv(val: Date | null) {
    this.ttvForm.waktu = val ? moment(val).format("YYYY-MM-DDTHH:mm") : "";
  }

  formatTime(dt: string) {
    return dt ? moment(dt).format("HH:mm") : "-";
  }

  openTtvDialog() {
    this.editingTtv = null;
    const now = moment().format("YYYY-MM-DDTHH:mm");
    this.ttvForm = {
      waktu: now, tekanan_darah_sistolik: null, tekanan_darah_diastolik: null,
      nadi: null, spo2: null, etco2: null, pola_nafas: null,
      suhu: null, fio2: null, mac: null, catatan: "",
    };
    this.dialogTtv = true;
  }

  editTtv(item: any) {
    this.editingTtv = item;
    this.ttvForm = {
      waktu: item.waktu ? moment(item.waktu).format("YYYY-MM-DDTHH:mm") : "",
      tekanan_darah_sistolik: item.tekanan_darah_sistolik,
      tekanan_darah_diastolik: item.tekanan_darah_diastolik,
      nadi: item.nadi,
      spo2: item.spo2,
      etco2: item.etco2,
      pola_nafas: item.pola_nafas,
      suhu: item.suhu,
      fio2: item.fio2,
      mac: item.mac,
      catatan: item.catatan || "",
    };
    this.dialogTtv = true;
  }

  async simpanTtv() {
    if (!(this.$refs.ttvForm as any).validate()) return;
    this.savingTtv = true;
    try {
      let resp;
      if (this.editingTtv) {
        resp = await PemantauanAnestesiSvc.updateTtv(this.pemantauan.id, this.editingTtv.id, this.ttvForm);
      } else {
        resp = await PemantauanAnestesiSvc.addTtv(this.pemantauan.id, this.ttvForm);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("TTV berhasil disimpan");
        this.dialogTtv = false;
        this.$emit("refresh");
      }
    } catch {
      // handled by service
    }
    this.savingTtv = false;
  }

  // Simpan semua baris input yang wajib-field-nya terisi, sekali klik.
  // Waktu tiap baris = mulai_anestesi_at + (nextMenit + i*5) menit (kelipatan 5).
  async simpanSemuaTtv() {
    const base = this.anchorWaktu;
    if (!base) {
      appModule.sendErrorAlert("Jam baris tidak dapat ditentukan");
      return;
    }
    const jobs = this.inlineRows
      .map((row: any, i: number) => ({ row, i }))
      .filter(({ row }) => row.tekanan_darah_sistolik && row.tekanan_darah_diastolik && row.nadi);

    if (!jobs.length) {
      appModule.sendErrorAlert("Isi minimal 1 baris (TD sistolik, diastolik, dan nadi)");
      return;
    }

    this.savingInline = true;
    let ok = 0;
    const keep: any[] = [];
    for (const { row, i } of jobs) {
      const waktu = moment(base).add(i * 5, "minutes").format("YYYY-MM-DDTHH:mm");
      try {
        const resp = await PemantauanAnestesiSvc.addTtv(this.pemantauan.id, { waktu, ...row });
        if (resp?.data?.status == "1") {
          ok++;
        } else {
          keep.push(row);
        }
      } catch {
        keep.push(row); // simpan data yang gagal agar bisa dikoreksi
      }
    }
    this.savingInline = false;

    if (ok > 0) {
      appModule.NoticeDelay(`${ok} TTV berhasil disimpan`);
      this.$emit("refresh");
    }
    this.resetInlineRows(keep);
  }

  async hapusTtv(item: any) {
    if (!confirm("Hapus data TTV ini?")) return;
    try {
      const resp = await PemantauanAnestesiSvc.deleteTtv(this.pemantauan.id, item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("TTV berhasil dihapus");
        this.$emit("refresh");
      }
    } catch {
      // handled by service
    }
  }
}
